'use client';

import { useMemo } from 'react';
import { useOthers, useSelf } from '@liveblocks/react';
import { Avatar, Inline } from '@org/design-system';
import { useCollaborationIdentity } from './PresenceProvider';
import { createAvatarFallback, getCollaboratorColor } from './presence';

function ActiveUsersStackInner() {
  const { me } = useCollaborationIdentity();
  const self = useSelf();
  const others = useOthers();

  const users = useMemo(() => {
    const everyone = others.map((other) => ({
      id: String(other.connectionId),
      name: (other.info as { name?: string } | undefined)?.name ?? `User ${other.connectionId}`,
      color: (other.info as { color?: string } | undefined)?.color ?? getCollaboratorColor(other.connectionId),
      activeField: other.presence.activeField,
    }));

    everyone.unshift({
      id: 'self',
      name: (self?.info as { name?: string } | undefined)?.name ?? me.name,
      color: (self?.info as { color?: string } | undefined)?.color ?? me.color,
      activeField: self?.presence.activeField ?? null,
    });

    return everyone;
  }, [me.color, me.name, others, self]);

  return (
    <Inline gap={1}>
      {users.map((user) => (
        <Avatar
          key={user.id}
          size="sm"
          fallback={createAvatarFallback(user.name)}
          style={{ outline: `1px solid ${user.color}` }}
          title={user.activeField ? `${user.name} — Editing ${user.activeField}` : `${user.name} — Viewing page`}
        />
      ))}
    </Inline>
  );
}

export function ActiveUsersStack() {
  const { enabled } = useCollaborationIdentity();
  if (!enabled) return null;
  return <ActiveUsersStackInner />;
}
